import React from "react";
import DuplexCategory from "../components/Houses/DuplexCategory";
import Navbar from "../components/homepage/Navbar";
import Footer from "../components/homepage/Footer";
const duplexCategoryPage = () => {
  return (
    <div>
      <Navbar />
      <DuplexCategory />
      <Footer />
    </div>
  );
};

export default duplexCategoryPage;
